module.exports = __webpack_public_path__ + "media/images/games/35gender/tinied/cars-d99c2da97eb3b8eebececc847e749d80.png";